<div class="access-denied-error-page">
  <mode-error-prompt [title]="errorTitle" [explanation]="errorExplanation" [instructions]="errorInstructions">
    <mode-error-prompt-actions>
      <capra-button-link
        data-test="home-button-link"
        [text]="errorPrimaryActionLabel"
        [href]="errorPrimaryActionTarget"
      />
    </mode-error-prompt-actions>
  </mode-error-prompt>
</div>
